import sysadmin from "./sysadmin.routes";
import functional from "./functional.routes";
import guards from "./guards.routes";
import embed from "./embed.routes";

// `embed` comes before `functional` on purpose: functional ends with the 404 aliased to `"*"`,
// and vue-router 3 matches in definition order (DL-452).
export default [...sysadmin, ...guards, ...embed, ...functional];
